/**
 * @since 2025-02-19
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import { initializeApp } from "firebase/app";
import {
  browserLocalPersistence,
  getAuth,
  GoogleAuthProvider,
  onAuthStateChanged,
  setPersistence,
  signInWithPopup,
} from "firebase/auth";

// Get configuration from public/config.js
const config = window.__APP_CONFIG__ || {};

// Use Firebase config from config.js - required if Firebase is enabled
const firebaseConfig = config.auth?.firebase?.config ?? config.FIREBASE_CONFIG ?? {};

// Initialize Firebase only if enabled
let app = null;
let auth = null;
let provider = null;

if (config.auth?.firebase?.enabled ?? config.ENABLE_FIREBASE_AUTHENTICATION) {
  // Initialize Firebase
  app = initializeApp(firebaseConfig);

  // Initialize Firebase Authentication and get a reference to the service
  auth = getAuth(app);

  // Initialize the Google Auth Provider
  provider = new GoogleAuthProvider();
} else {
  // Create mock objects to prevent errors when Firebase is disabled
  auth = {
    signOut: async () => {},
    onAuthStateChanged: () => () => {},
  };
  provider = {};
}

// Export everything you need
export {
  app,
  auth,
  browserLocalPersistence,
  firebaseConfig,
  onAuthStateChanged,
  provider,
  setPersistence,
  signInWithPopup,
};
